import { render, staticRenderFns } from "./Layout_UserDetailsSection.vue?vue&type=template&id=740e2052&scoped=true&"
import script from "./Layout_UserDetailsSection.vue?vue&type=script&lang=js&"
export * from "./Layout_UserDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./Layout_UserDetailsSection.vue?vue&type=style&index=0&id=740e2052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740e2052",
  null
  
)

export default component.exports